import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export type CursorPagination<T> = {
  next?: string;
  prev?: string;
  results: T[];
};

export const cursorPaginationSchema = <T>(schema: Schema<T>) =>
  z.object({
    next: cz.optional(z.string()),
    prev: cz.optional(z.string()),
    results: cz.forcedArray(schema),
  });
